import { number2ordinal } from "@Common/helpers/number";
import { or } from "./sonar";

const isSortedDate = (sortBy = "") => sortBy?.includes("date") || sortBy?.includes("Date");

function sortCollectionBy(collection = [], sortBy = "", order = "ASC") {
	if (collection.length && sortBy) {
		collection.sort((elementA, elementB) => {
			if (isSortedDate(sortBy)) {
				return new Date(elementA[sortBy]).getTime() > new Date(elementB[sortBy]).getTime() ? 1 : -1;
			} else {
				return elementA[sortBy] > elementB[sortBy] ? 1 : -1;
			}
		});
	}

	if (order === "DESC") {
		collection = collection.reverse();
	}

	return collection;
}

function formatSideMenu(list, year, element) {
	let found = false;
	list.forEach((item) => {
		if (item.title === year) {
			item.list.push(element);
			found = true;
		}
	});
	if (!found) {
		list.push({
			_id: year.toString(),
			title: year.toString(),
			bold: true,
			list: [element],
		});
	}
	return list;
}

function getCurrentCommissionCycle(list = [], onlyActive = false, defaultByDate = false) {
	let current = null;

	const ordered = sortCollectionBy([...list], "startDate");
	const activeCycles = [];
	const today = new Date();

	while (ordered?.length) {
		const actual = ordered.pop();

		if (
			or(
				defaultByDate && new Date(actual.endDate) > today,
				(actual.status === "CLOSING" || actual.status === "POSTED") && !onlyActive && !defaultByDate
			)
		) {
			current = actual;
			break;
		}

		if (actual.status === "ACTIVE") {
			activeCycles.push(actual);
		}
	}

	if (!current && activeCycles?.length) {
		current = activeCycles.pop();
	}

	return current;
}

function getCurrentPayPeriod(list = []) {
	const now = Date.now();
	let result = list.find((entry) => {
		const startDate = new Date(entry.startDate);
		const endDate = new Date(entry.endDate);

		return now >= startDate && now <= endDate;
	});

	if (!result) {
		const ordered = sortCollectionBy([...list], "startDate");
		result = ordered.pop();
	}

	return {
		...result,
		_id: result._id,
	};
}

function prepareOrdinal(number) {
	return number2ordinal(parseInt(number, 10));
}

function prepareIntervalCode(code) {
	code = code.toLowerCase();
	code = code.replace("_", "-");
	code = code.charAt(0).toUpperCase() + code.substring(1);
	return code;
}

function getPayPeriodTitleExtended(commissionCycle, periodTitle) {
	return `${commissionCycle.title} ${periodTitle}`;
}

function getLatestPayPeriodInThisCC(commissionCycle) {
	const payPeriods = commissionCycle?.payPeriods || [];
	const ordered = sortCollectionBy([...payPeriods], "startDate");
	const filtered = ordered.filter((entry) => new Date(entry.endDate) <= new Date(commissionCycle.endDate));
	const result = filtered.pop();

	return {
		...result,
		_id: result._id,
	};
}

export {
	sortCollectionBy,
	formatSideMenu,
	getCurrentCommissionCycle,
	getCurrentPayPeriod,
	getPayPeriodTitleExtended,
	getLatestPayPeriodInThisCC,
};
